import { PropsWithChildren } from 'react';
import * as React from 'react';

export const NavbarNavMenuUserMenuItem: React.FC<PropsWithChildren<React.HTMLProps<HTMLLIElement>>> = ({ children, ...others }) => (
    <li role="none" {...others}>
        {children}
    </li>
);
